import type { BorescopeFinding } from '@avisoma/shared';
import { Th, TruncatedTd } from './cells';
import { extractionTableClass, extractionTbodyClass, extractionTheadClass } from './tableClasses';

/**
 * The finding rows of one borescope / inspection record (DR-4817): one row per inspected area,
 * with its finding, disposition and AMM / EM reference as printed. Read-only; the page card
 * shows it under the record's scalars.
 */
export function BorescopeFindingsTable({ rows }: { rows: BorescopeFinding[] }) {
  return (
    <table className={extractionTableClass}>
      <thead className={extractionTheadClass}>
        <tr>
          <Th>Area</Th>
          <Th>Finding</Th>
          <Th>Disposition</Th>
          <Th>Reference</Th>
        </tr>
      </thead>
      <tbody className={extractionTbodyClass}>
        {rows.map((row, index) => (
          <tr key={`${row.area ?? 'area'}-${index}`}>
            <TruncatedTd value={row.area} maxWidth="max-w-[200px]" />
            <TruncatedTd value={row.finding} maxWidth="max-w-[360px]" />
            <TruncatedTd value={row.disposition} maxWidth="max-w-[220px]" />
            <TruncatedTd value={row.reference} maxWidth="max-w-[220px]" className="font-mono" />
          </tr>
        ))}
      </tbody>
    </table>
  );
}
